import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { getThemeByType } from 'utils/common';
import { Panel, BackToPrev } from 'components/ui/index';
import { tryFetchModuleData } from 'components/page/DetailsSubpanels/flow/actions';
import styles from '../index.less';

const ListItem = List.Item;
const cx = classNames.bind(styles);

const propTypes = {
  taskData: PropTypes.object,
  prioritiesList: PropTypes.array,
  statusesList: PropTypes.array,
};

const defaultProps = {
  taskData: {},
  prioritiesList: [],
  statusesList: [],
};

class TaskDetailCard extends React.Component {
  parseData = (id, list) => {
    const value = list.find(x => x.id === id);
    if (!_.isEmpty(value) && value.display_value) {
      return value.display_value;
    }
    return '';
  }

  render() {
    const { taskData, prioritiesList, statusesList } = this.props;
    const i18n = 'page.taskDetails.labels';
    const list = [
      {
        key: 'subject',
        label: <FormattedMessage id={`${i18n}.subject`} />,
        value: taskData.subject ? taskData.subject : '',
      },
      {
        key: 'status',
        label: <FormattedMessage id={`${i18n}.status`} />,
        value: this.parseData(taskData.status_code, statusesList),
      },
      {
        key: 'priotity',
        label: <FormattedMessage id={`${i18n}.priority`} />,
        value: this.parseData(taskData.priority_code, prioritiesList),
      },
      {
        key: 'dueDate',
        label: <FormattedMessage id={`${i18n}.dueDate`} />,
        value: taskData.due_date ? taskData.due_date : '',
      },
      {
        key: 'relatedTo',
        label: <FormattedMessage id={`${i18n}.relatedTo`} />,
        value: !_.isEmpty(taskData.relate_user) && taskData.relate_user.name ? taskData.relate_user.name : '',
      },
      {
        key: 'comment',
        label: <FormattedMessage id={`${i18n}.comments`} />,
        value: taskData.comments ? taskData.comments : '',
      },
    ];

    return (
      <div className={classNames(cx('tasks-card-wrapper'), 'mb-lg')}>
        <List
          dataSource={list}
          className="tasks-card-list"
          renderItem={item => (
            <ListItem key={item.key}>
              <div className={classNames(cx('card-content-label'), 'mr-md')}>{item.label}: </div>
              <div className={classNames(cx('card-content-value'))}>{item.value}</div>
            </ListItem>
          )}
        />
      </div>
    );
  }
}

TaskDetailCard.propTypes = propTypes;
TaskDetailCard.defaultProps = defaultProps;

export default TaskDetailCard;



// WEBPACK FOOTER //
// ./src/views/ObjectTask/components/TaskDetailCard.jsx